import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { FundraisingResponse } from '@shared/schemas';

import { initialState } from './fundraisings.state';

/**
 * Fundraisings index slice. Reducers are pure state transitions only; the
 * fetch itself lives in the saga, which dispatches these `load*` transitions
 * as it progresses.
 */
const slice = createSlice({
  name: 'fundraisings',
  initialState,
  reducers: {
    loadStarted: (state) => {
      state.loading = true;
      state.error = null;
    },
    /** Rows are stored as returned; the DataGrid owns the sorting. */
    loadSucceeded: (state, action: PayloadAction<FundraisingResponse[]>) => {
      state.rows = action.payload;
      state.loading = false;
      state.loaded = true;
    },
    loadFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.loaded = true;
      state.error = action.payload;
    },
  },
});

export const fundraisingsActions = slice.actions;
export const fundraisingsReducer = slice.reducer;
